(function($) {$(document).ready(function() {

	$('a[href^="#"]').on('click', event => {
		const href = $(event.target).attr('href');

		if (href === '#') return;

		const $target = $(href);

		if ($target.length === 0) return;

		event.preventDefault();

		$('html, body').animate({scrollTop: $target.offset().top}, 700);
	});

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);